var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessengerApp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint0_radial_5571_23766)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.64258 19.5982C6.64258 12.155 12.4763 6.64185 19.9996 6.64185C27.5229 6.64185 33.3566 12.1583 33.3566 19.6015C33.3566 27.0447 27.5229 32.5578 19.9996 32.5578C18.6472 32.5578 17.3516 32.3775 16.1327 32.0436C15.8957 31.9801 15.6419 31.9968 15.4181 32.097L12.7668 33.2657C12.0722 33.5729 11.2908 33.0787 11.2674 32.3207L11.194 29.9432C11.1873 29.6493 11.0537 29.3755 10.8367 29.1818C8.23874 26.8577 6.64258 23.4917 6.64258 19.5982ZM15.9021 17.1638L11.9785 23.3882C11.6011 23.986 12.3358 24.6571 12.8968 24.2297L17.1109 21.0307C17.3947 20.8137 17.7888 20.8137 18.0759 21.0274L21.1981 23.3682C22.1365 24.0694 23.4722 23.8257 24.0966 22.8339L28.0236 16.6129C28.3976 16.0151 27.6629 15.3406 27.1019 15.768L22.8878 18.967C22.604 19.1841 22.2099 19.1841 21.9228 18.9704L18.8006 16.6296C17.8622 15.9283 16.5265 16.1721 15.9021 17.1638Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5571_23766",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.7 39.7853) scale(43.584 43.5801)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6098,
    stopColor: "#A033FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9348,
    stopColor: "#FF5280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7061"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessengerApp);
export default __webpack_public_path__ + "static/media/messengerApp.4da1264655b6dd5c298181f3a0ecb72e.svg";
export { ForwardRef as ReactComponent };